import { render, staticRenderFns } from "./UnpostedPaymentsWidget.vue?vue&type=template&id=4a8b37fc&scoped=true&"
import script from "./UnpostedPaymentsWidget.vue?vue&type=script&lang=js&"
export * from "./UnpostedPaymentsWidget.vue?vue&type=script&lang=js&"
import style0 from "./UnpostedPaymentsWidget.vue?vue&type=style&index=0&id=4a8b37fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8b37fc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VDivider,VIcon,VProgressCircular})
